module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./d3.js"));
	}, "d3");
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/bundle-loader?lazy&name=d3!../~/d3/d3.js
 ** module id = 58
 ** module chunks = 0
 **/